import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { DsToastTheme } from '@design-system/ds-toast/types/ds-toast-theme.type';
import { DsIconButtonComponent } from '@design-system/ds-icon-button/component/ds-icon-button.component';

@Component({
  selector: 'ds-toast',
  standalone: true,
  imports: [CommonModule, MatIconModule, DsIconButtonComponent],
  templateUrl: './ds-toast.component.html',
  styleUrls: ['./ds-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsToastComponent {
  /**
   * Controls the visual state of the toast.
   *
   * @default 'info'
   */
  @Input() theme: DsToastTheme = 'info';

  /**
   * Toast title displayed in the first line.
   */
  @Input() header = '';

  /**
   * Additional descriptive message displayed under the title.
   */
  @Input() content = '';

  /**
   * Controls whether the close action is shown.
   *
   * @default true
   */
  @Input() hasClose = true;

  /**
   * Event emitted when close action is clicked.
   */
  @Output() closeClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  /**
   * Returns all CSS classes required for the toast card.
   */
  get hostClasses(): string[] {
    return ['ds-toast--' + this.theme];
  }

  /**
   * Returns icon name based on the selected theme.
   */
  get themeIcon(): string {
    switch (this.theme) {
      case 'success':
        return 'check_circle';
      case 'warning':
        return 'warning';
      case 'error':
        return 'cancel';
      case 'info':
      default:
        return 'info';
    }
  }
}
